// Define permissions - avoid using the literal permission names to reduce
// the chance of a typo.

const editProvider = 'Edit Provider';
const createListings = 'Create Listings';
const editListings = 'Edit Listings';
const viewUsers = 'View Users';
const inviteUsers = 'Invite Users';
const editUserRoles = 'Edit User Roles';
const removeUsers = 'Remove Users';
const viewAnalytics = 'View Provider Analytics';
const createReviewResponses = 'Create Review Responses';
const editReviewResponses = 'Edit Review Responses';
const createProvider = 'Create Provider';
const viewBilling = 'View Billing';
const editBilling = 'Edit Billing';

export {
  editProvider,
  createListings,
  editListings,
  viewUsers,
  inviteUsers,
  editUserRoles,
  removeUsers,
  viewAnalytics,
  createReviewResponses,
  editReviewResponses,
  createProvider,
  viewBilling,
  editBilling,
};
